import { Checkbox, Stack, Typography } from '@mui/material';
import { CTRInfoPanel } from '@components/Questions/CTRQuestion/CTRInfoPanel/CTRInfoPanel';
import { refineFonts } from '@/Theming/refineFonts';
import { useContext, useEffect, useRef, useState } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { useInvestigationDetails } from '@hooks/useInvestigationDetails';
import { config } from '@branding/config';
import { usePostHog } from 'posthog-js/react';

interface ICTRQuestionProps {
	isCheckboxInvalid: boolean;
	setCTRCheckbox?: (value: boolean) => void;
	setCurrentAnswer: (answerId: any, answerText?: any) => void;
}

export const CTRQuestion = ({ isCheckboxInvalid, setCTRCheckbox, setCurrentAnswer }: ICTRQuestionProps) => {
	const [checked, setChecked] = useState(false);
	const investigationDetails = useInvestigationDetails();
	const posthog = usePostHog();

	useEffect(() => {
		if (posthog && !config.isDevelopment) {
			posthog.setPersonProperties({
				isCTR: true,
			});
		}
		setCurrentAnswer('', '');
	}, []);

	const { CTR } = useContext(LocalizationContext);

	const scrollTargetRef = useRef<any>(null);
	const errorTextRef = useRef<any>(null);

	useEffect(() => {
		if (scrollTargetRef.current && isCheckboxInvalid) {
			scrollTargetRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [isCheckboxInvalid]);

	const handleStackClick = () => {
		setChecked((prevState) => {
			const newState = !prevState;
			setCTRCheckbox!(newState);

			if (newState) {
				setCurrentAnswer('ctrQuestion', CTR.CheckboxLabel);
			} else {
				setCurrentAnswer('', '');
			}
			return newState;
		});
	};

	return (
		<Stack data-cy={'ctrQuestion'} alignItems={'center'} overflow={'scroll'}>
			<Stack maxWidth={'650px'} gap={'24px'} alignItems={'start'}>
				<Typography variant={'questionText'} textAlign="left">
					{investigationDetails?.nextQuestion?.questionText}
				</Typography>
				<CTRInfoPanel />
				<Stack gap={'4px'}>
					<Stack
						gap={'4px'}
						direction={'row'}
						alignItems={'center'}
						onClick={handleStackClick}
						justifyContent={'start'}>
						<Checkbox
							checked={checked}
							sx={{
								padding: '0',
								color: isCheckboxInvalid ? '#D23C3C' : '',
								alignSelf: 'center',
							}}
							data-cy={'ctrCheckbox'}
						/>
						<Typography ref={scrollTargetRef} textAlign={'start'} sx={{ ...refineFonts.mediumRegular }}>
							{CTR.CheckboxLabel}
						</Typography>
					</Stack>
					{isCheckboxInvalid && (
						<Typography
							ref={errorTextRef}
							sx={{ ...refineFonts.smallRegular, color: '#C02020', paddingLeft: '28px' }}>
							{CTR.CheckboxError}
						</Typography>
					)}
				</Stack>
			</Stack>
		</Stack>
	);
};
